<template>
  <div class="my-4">
    <document-type-header
      :title="title"
      :statusLabel="statusLabel"
      :statusIcon="statusIcon"
      :subTitle="subTitle">
      <slot>
      </slot>
    </document-type-header>

    <div class="mt-2 form-group">
      <multiple-documents-upload
        :multiple="multipleDocs"
        :canAdd="canAdd"
        :canDelete="canDelete"
        :canReplace="canReplace || canForceReplace"
        v-model="uploadedFiles"
        :id="name"
        :hasError="fileHasError"
        :errorMsg="$t('errors.invalid_rib')"
        @resetError="resetError">
      </multiple-documents-upload>
    </div>

    <div v-if="isVisible" class="my-4">
      <div v-if="documentFields.length">
        <div class="information_check_no">
          {{ $t('iframe_page.check_informations_3')}}
        </div>
        <br>
        <adaptative-placeholder-input v-for="(field, index) in documentFields"
          :key="index"
          :label="$t('businessDocuments.serialize.' + docType + '.' + field.name)"
          :inputFormating="formateData(field.name)"
          v-model="documentFields[index].value"
          :hasError="documentFields[index].hasError"
          :errorMessage="documentFields[index].errorMessage">
        </adaptative-placeholder-input>
      </div>
      <button
        type="button"
        class="validation-btn LMSG-background-color"
        :disabled="fileHasError || showLoader"
        @click="onClick">
        {{ $t('creation_forms.vldt') }}
      </button>
    </div>

  </div>
</template>

<script>
import AdaptativePlaceholderInput from './AdaptativePlaceholderInput.vue'
import DocumentTypeHeader from './DocumentTypeHeader.vue'
import multipleDocumentsUpload from './multipleDocumentsUpload.vue'

import {validateIBAN, validateIBANRIBKey} from '@/helpers/validator'

import status from './data/status.js'
import globalStatus from './data/globalStatus.js'
import docTypes from './data/docType.js'
import possibleDocuments from '@/helpers/documentSerialize.json'

export default {
  name: 'DocumentTypeForm',
  components: {
    docTypes,
    'adaptative-placeholder-input': AdaptativePlaceholderInput,
    'document-type-header': DocumentTypeHeader,
    'multiple-documents-upload': multipleDocumentsUpload
  },
  props: {
    canForceReplace: {
      Type: Boolean,
      default: false
    },
    docType: {
      type: String,
      default: ''
    },
    idDocument: {
      type: String,
      default: ''
    },
    informations: {
      type: String,
      default: ''
    },
    multipleDocs: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    onValidate: {
      type: Function
    },
    subTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    canAdd () {
      return this.statusId === status.TO_COMPLETE && Object.keys(docTypes).map(elem => docTypes[elem]).includes(this.docType)
    },
    canDelete () {
      return this.statusId === status.TO_COMPLETE && Object.keys(docTypes).map(elem => docTypes[elem]).includes(this.docType)
    },
    canReplace () {
      return this.statusId === status.REFUSED && Object.keys(docTypes).map(elem => docTypes[elem]).includes(this.docType)
    },
    isRIB () {
      return this.docType === docTypes.RIB
    },
    isVisible () {
      return this.statusId === status.TO_COMPLETE && this.uploadedFiles.length && !this.fileHasError
    },
    uploadedFiles: {
      get () {
        return this.value
      },
      set (val) {
        if (this.ocr && val && val.length) {
          let that = this
          that.showLoader = true
          this.$f7.showPreloader(that.$t('common.getting_file'))
          this.$engine.services.ocr(
            that.$engine.user.get().id,
            '',
            val[0].Data,
            val[0].Name.split('.').pop(),
            'scan',
            this.getDocType()
          ).then(resp => {
            that.$f7.hidePreloader()
            that.showLoader = false
            that.$emit('input', val)
            if (resp && resp.data && resp.data.ControlsInformations) {
              let foundElems = Object.keys(resp.data.ControlsInformations)
              foundElems.forEach((item, index) => {
                let indexField = that.documentFields.map(elem => elem.name).indexOf(item)
                if (indexField !== -1) {
                  that.documentFields[indexField].value = resp.data.ControlsInformations[item].Value
                  that.documentFields[indexField].hasError = resp.data.ControlsInformations[item].Valid === '0'
                  that.documentFields[indexField].hasWarning = resp.data.ControlsInformations[item].Valid === '2'
                  that.documentFields[indexField].errorMessage = resp.data.ControlsInformations[item].Description
                }
              })
            }
          }).catch(err => {
            console.log(err)
            that.$f7.hidePreloader()
            that.fileHasError = true
            that.showLoader = false
          })
        } else {
          this.$emit('input', val)
        }
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.pickStatus(this.getGlobalStatus(newVal))
    }
  },
  data: function () {
    return {
      statusId: '0',
      statusLabel: '',
      statusIcon: '',
      fileHasError: false,
      showLoader: false,
      documentFields: [],
      iban: '',
      ibanHasError: false,
      ibanErrorMessage: '',
      bic: '',
      bicHasError: false,
      bicErrorMessage: '',
      bank: '',
      bankHasError: false,
      bankErrorMessage: '',
      bankAddress: '',
      bankAddressHasError: false,
      bankAddressErrorMessage: '',
      bankZip: '',
      bankZipHasError: false,
      bankZipErrorMessage: '',
      bankCity: '',
      bankCityHasError: false,
      bankCityErrorMessage: ''
    }
  },
  created () {
    this.ocr = possibleDocuments[this.docType].ocr
    let that = this
    possibleDocuments[this.docType].fields.forEach(item => {
      that.documentFields.push({
        name: item.name,
        type: item.type,
        value: undefined,
        editable: item.change === '1',
        HasError: false,
        errorMessage: ''
      })
    })
  },
  mounted () {
    this.pickStatus(this.getGlobalStatus(this.value))
  },
  methods: {
    checkFields () {
      let result = true
      if (!this.iban) {
        result = false
        this.ibanHasError = true
        this.ibanErrorMessage = this.$t('errors.is_mandatory', {mandatoryValue: this.$t('iframe_page.iban')})
      } else if (!validateIBAN(this.iban.replace(/\s/g, ''))) {
        result = false
        this.ibanHasError = true
        this.ibanErrorMessage = this.$t('errors.rib_format_incorrect')
      } else if (!validateIBANRIBKey(this.iban.replace(/\s/g, ''))) {
        result = false
        this.ibanHasError = true
        this.ibanErrorMessage = this.$t('errors.rib_key_incorrect')
      } else {
        this.ibanHasError = false
      }
      if (!this.bic) {
        result = false
        this.bicHasError = true
        this.bicErrorMessage = this.$t('errors.is_mandatory', {mandatoryValue: this.$t('iframe_page.bic')})
      } else {
        this.bicHasError = false
      }
      // if (!this.bank) {
      //   result = false
      //   this.bankHasError = true
      //   this.bankErrorMessage = this.$t('errors.is_mandatory', {mandatoryValue: this.$t('iframe_page.banque')})
      // } else {
      //   this.bankHasError = false
      // }
      // if (!this.bankAddress) {
      //   result = false
      //   this.bankAddressHasError = true
      //   this.bankAddressErrorMessage = this.$t('errors.is_mandatory', {mandatoryValue: this.$t('iframe_page.bank_address')})
      // } else {
      //   this.bankAddressHasError = false
      // }
      // if (!this.bankZip) {
      //   result = false
      //   this.bankZipHasError = true
      //   this.bankZipErrorMessage = this.$t('errors.is_mandatory', {mandatoryValue: this.$t('iframe_page.bank_zip')})
      // } else {
      //   this.bankZipHasError = false
      // }
      // if (!this.bankCity) {
      //   result = false
      //   this.bankCityHasError = true
      //   this.bankCityErrorMessage = this.$t('errors.is_mandatory', {mandatoryValue: this.$t('iframe_page.bank_city')})
      // } else {
      //   this.bankCityHasError = false
      // }
      return result
    },
    formateData (field) {
      switch (field) {
        case 'Iban':
          return this.formateIBAN
        default:
          return undefined
      }
    },
    formateIBAN (val) {
      console.log(val)
      val = val.replace(/\s/g, '').slice(0, 34)
      if (val) {
        val = val.match(/.{1,4}/g)
        if (val) {
          val = val.join(' ')
        }
      }
      return val
    },
    getDocType () {
      switch (this.name) {
        case 'docTypeFormStatus':
          return 'STATUS'
        case 'docTypeFormRIB':
          return 'RIB'
        case 'docTypeFormKBIS':
          return 'KBIS'
        case 'docTypeFormPIMain':
          return 'IDCARD'
      }
    },
    getGlobalStatus (docList) {
      if (!docList.length || docList.filter(elem => !elem.Status || globalStatus.TO_COMPLETE.includes(elem.Status)).length) {
        return '0'
      } else if (docList.filter(elem => globalStatus.VERIFYING.includes(elem.Status)).length) {
        return '1'
      } else if (docList.filter(elem => globalStatus.EXPIRED.includes(elem.Status)).length) {
        return '2'
      } else if (docList.filter(elem => globalStatus.VALIDATED.includes(elem.Status)).length) {
        return '3'
      } else if (docList.filter(elem => globalStatus.REFUSED.includes(elem.Status)).length) {
        return '4'
      }
    },
    onClick () {
      this.onValidate ? this.onValidate() : this.validateButton()
    },
    pickStatus (statusToIdentify) {
      switch (statusToIdentify) {
        case status.TO_COMPLETE:
          this.statusId = status.TO_COMPLETE
          this.statusLabel = this.$t('iframe_page.status.to_complete')
          this.statusIcon = ''
          break
        case status.VERIFYING:
          this.statusId = status.VERIFYING
          this.statusLabel = this.$t('iframe_page.status.waiting')
          this.statusIcon = ''
          break
        case status.ACCEPTED:
          this.statusId = status.ACCEPTED
          this.statusLabel = ''
          this.statusIcon = 'success LMSGcolor'
          break
        case status.REFUSED:
          this.statusId = status.REFUSED
          this.statusLabel = this.$t('iframe_page.status.refused')
          this.statusIcon = 'icon fa-warning-o text-warning'
          break
      }
    },
    resetError () {
      this.fileHasError = false
      this.statusId = status.TO_COMPLETE
    },
    validateButton () {
      let that = this
      if (this.isRIB && !this.checkFields()) {
        return
      }
      let docData = ''
      that.uploadedFiles.forEach((item, i) => {
        docData += i === 0 ? item.Data : ';' + item.Data.substring(item.Data.indexOf(',') + 1)
      })
      this.showLoader = true
      this.$f7.showPreloader(that.$t('loading.sending_document'))
      this.$engine.services.suppliers.uploadDocument({
        IdDocument: that.idDocument,
        DocumentType: that.docType,
        DocumentName: that.uploadedFiles[0].Name,
        ocr: that.ocr ? '1' : '0',
        DocumentData: docData,
        Serialize: {
          Iban: this.iban.split(' ').join(''),
          Bic: this.bic,
          Name: this.bank,
          BankAdress: this.bankAddress,
          BankZip: this.bankZip,
          BankCity: this.bankCity
        },
        IdSeller: this.$engine.user.get().IdSeller
      })
      .then(resp => {
        that.pickStatus(status.VERIFYING)
        that.showLoader = false
        that.$f7.hidePreloader()
        // that.$bus.$emit('mainNotif', { text: this.$t('iframe_page.valid_documents_1') + this.$t('iframe_page.valid_documents_2') })
      })
      .catch(err => {
        console.log(err)
        that.fileHasError = true
        that.uploadedFiles = []
        that.showLoader = false
      })
    }
  }
}
</script>

<style scoped>
@import '../LMSGstyle.css';
.information_check_no {
  color: #49A0A2;
}
</style>
